module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-form-select-container",
    class: [_vm.marginClasses, _vm.sizeClasses]
  }, [(_vm.showLabel) ? _c('BaseLabel', {
    attrs: {
      "size": _vm.size,
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sc-select-box",
    class: {
      'has-error': _vm.error && !_vm.value.length, disabled: _vm.disabledClass
    }
  }, [_c('div', {
    ref: (_vm.computedName + "-sc-selectbox"),
    staticClass: "sc-select-button brd",
    class: {
      'open-select-box': _vm.showOptions,
    },
    style: (("z-index:" + (_vm.highestZIndex + (_vm.showOptions ? 5 : 3))))
  }, [_c('div', {
    staticClass: "sc-selected-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select_query),
      expression: "select_query"
    }],
    staticClass: "sc-select-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "new-off",
      "readonly": !_vm.showOptions
    },
    domProps: {
      "value": (_vm.select_query)
    },
    on: {
      "focus": _vm.showOption,
      "click": _vm.showOption,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.deleteEmpty()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.select_query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.error && !_vm.value.length) ? _c('div', {
    staticClass: "input-error",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Error.svg"),
      "alt": "Error"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.success) ? _c('div', {
    staticClass: "input-checked"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Checked.svg"),
      "alt": "Checked"
    }
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "sc-select-chevrons"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/symbols-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptions),
      expression: "showOptions"
    }, {
      name: "closable",
      rawName: "v-closable",
      value: ({
        exclude: [(_vm.computedName + "-sc-selectbox")],
        handler: 'onClose',
      }),
      expression: "{\n          exclude: [`${computedName}-sc-selectbox`],\n          handler: 'onClose',\n        }"
    }],
    staticClass: "sc-options",
    style: (("z-index:" + (_vm.highestZIndex + 4))),
    attrs: {
      "id": (_vm.computedName + "-sc-options")
    }
  }, [(_vm.availableOptions.length) ? [(_vm.selectedOption) ? _c('div', {
    key: _vm.id + '_' + _vm.selectedOption[_vm.optionLabel],
    staticClass: "sc-option sc-selected"
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("\n              " + _vm._s(_vm._f("TitleString")(_vm.optionLabel ?
    _vm.selectedOption[_vm.optionLabel] :
    _vm.selectedOption)) + "\n              "), (_vm.optionSubLabel) ? _c('span', {
    staticClass: "sc-select-option-sub-label"
  }, [_vm._v(_vm._s(_vm._f("UpperString")(_vm.optionSubLabel ?
    _vm.selectedOption[_vm.optionSubLabel] :
    "")))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.availableOptions), function(option, index) {
    return (
      _vm.selectedOption &&
      _vm.selectedOption[_vm.optionValue] != option[_vm.optionValue]
    ) ? _c('div', {
      key: _vm.id + '_' + index + '_' + option[_vm.optionLabel],
      staticClass: "sc-option",
      class: {
        'sc-selected':
        _vm.selectedOption &&
          _vm.selectedOption[_vm.optionValue] == option[_vm.optionValue],
      },
      on: {
        "click": function($event) {
          return _vm.handleInput(index)
        }
      }
    }, [_c('span', {
      staticClass: "sc-select-option-label"
    }, [_vm._v("\n              " + _vm._s(_vm._f("TitleString")(_vm.optionLabel ? option[_vm.optionLabel] : option)) + "\n              "), (_vm.optionSubLabel) ? _c('span', {
      staticClass: "sc-select-option-sub-label"
    }, [_vm._v(_vm._s(_vm._f("UpperString")(_vm.optionSubLabel ? option[_vm.optionSubLabel] : "")))]) : _vm._e()])]) : _vm._e()
  })] : [_c('div', {
    staticClass: "sc-option"
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Nothing found")])])]], 2)])], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37742dd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseSelect.vue
// module id = 109
// module chunks = 0